import React, { useState, useEffect } from 'react';
import '../Details/style.css';

const carouseItem = [
  {
    pic: require('../../assets/newjuniorkalam/1.png'),
    name: 'Aadwit Mann Singh',
    work: 'Aadwit made a Pen that can be used in Space',
  },
  {
    pic: require('../../assets/newjuniorkalam/2.png'),
    name: 'Deekshita M',
    work: 'Deekshita interned under a Prominent Scientist',
  },
  {
    pic: require('../../assets/newjuniorkalam/3.png'),
    name: 'Devang Dwivedi',
    work: 'Devang calculated the radius of Earth using Eratosthenes Method',
  },
  {
    pic: require('../../assets/newjuniorkalam/4.png'),
    name: 'Gunin Chaudhary',
    work: 'Gunin won the PI Day Competition',
  },
  {
    pic: require('../../assets/newjuniorkalam/5.png'),
    name: 'Pranjal Manna',
    work: 'Pranjal held an Intenration Space Conference',
  },
  {
    pic: require('../../assets/newjuniorkalam/6.png'),
    name: 'Riyad Pathan',
    work: 'Riyad hosted a Space Quiz at his School',
  },
  {
    pic: require('../../assets/newjuniorkalam/7.png'),
    name: 'Shourya Deshmukh',
    work: 'Shourya conducted live observation from a remote telescope',
  },
  {
    pic: require('../../assets/newjuniorkalam/8.png'),
    name: 'Tavish Nischal',
    work: 'Tavish won International Space Debate',
  },
  {
    pic: require('../../assets/newjuniorkalam/9.png'),
    name: 'Vedant Kapoor',
    work: 'Vedant organised International Space Week Competion',
  },
  {
    pic: require('../../assets/newjuniorkalam/10.png'),
    name: 'Vihaan Kaushik',
    work: 'Vihaan discovered a New Star from Telescope Data',
  },
];

const Details = ({ joinHandler }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [length, setLength] = useState(carouseItem.length);
  const [carouselWork, setWork] = useState(true);
  const [touchPosition, setTouchPosition] = useState(null);

  const show = 4;

  //   const [touchPosition, setTouchPosition] = useState(null);

  // Set the length to match current children from props
  useEffect(() => {
    setLength(carouseItem.length);
  }, []);

  const next = () => {
    if (!carouselWork) return;
    if (currentIndex <= length - show + 1) {
      setCurrentIndex((prevState) => prevState + 1);
    } else {
      //   children.reverse();
      setCurrentIndex(0);
    }
  };

  const prev = () => {
    if (!carouselWork) return;

    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!carouselWork) return;
      else next();
    }, 5000);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [currentIndex, carouselWork, next]);

  return (
    <div className='wrapper-div'>
      <div className='metro-rocks'></div>
      <div className='creators-div'>
        <span className='creators-heading'>
          Curriculum <span className='creators-heading-color'>Creators</span>
        </span>
        <div className='creators'>
          <div className='creator'>
            <div className='creator-pic'></div>
            <span className='creator-name'>
              Cath <span className='creator-name-color'>Jama</span>
            </span>
            <span className='creator-pos'>
              Member at Bolton
              <br />
              Education Council
            </span>
          </div>
          <div className='creator'>
            <div
              className='creator-pic'
              style={{
                background: `url(${require('../../assets/anuradha.png')})`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
            <span className='creator-name'>
              Mrs Anuradha <span className='creator-name-color'>Mathur</span>
            </span>
            <span className='creator-pos'>
              HOD
              <br />
              Physics-NCERT
            </span>
          </div>
          <div className='creator'>
            <div
              className='creator-pic'
              style={{
                background: `url(${require('../../assets/pramod.png')})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
            <span className='creator-name'>
              Pramod <span className='creator-name-color'>Tanwar</span>
            </span>
            <span className='creator-pos'>
              Chief Project Scientist
              <br />
              at CSIR-CEERI
            </span>
          </div>
          <div className='creator'>
            <div
              className='creator-pic'
              style={{
                background: `url(${require('../../assets/nina.png')})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
            <span className='creator-name'>
              Nina <span className='creator-name-color'>Williams</span>
            </span>
            <span className='creator-pos'>
              IB Educational
              <br />
              Expert
            </span>
          </div>
        </div>
        <span className='creators-btn' onClick={joinHandler}>
          Join Now
        </span>
      </div>
      <div className='community-div'>
        <div className='mobile-rocket'></div>
        <span className='community-headline'>
          Join our community with over <br />
          <b style={{ fontWeight: 'bolder' }}>30,000</b> Curious Children
        </span>
        <div className='carousel-div'>
          <div
            className='carousel'
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            id='carousel'
          >
            {carouseItem.map((item, index) => (
              <div
                className='carousel-item'
                onMouseDown={() => {
                  setWork((work) => !work);
                }}
                onMouseUp={() => {
                  setWork((work) => !work);
                }}
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`,
                  transition: 'all 0.5s ease-in-out',
                }}
                key={index}
              >
                <div
                  className='carousel-pic'
                  style={{
                    background: `url(${item.pic})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                  }}
                ></div>
                <div className='carousel-info'>
                  <span className='carousel-name'>{item.name}</span>
                  <span className='carousel-name-mobile'>{item.name}</span>
                  <span className='carousel-detail'>{item.work}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
